<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TimelineMax as Line, Power1 } from 'gsap'

import Widget from '@/components/widget'
import BaseButton from '@/components/base-button'

export default {

  name: 'PartnersWidget',

  mixins: [Widget],

  components: {
    BaseButton
  },

  data () {
    return {
      tl: null
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })

      const els = [
        this.$refs.heading,
        this.$refs.subheading,
        this.$refs.aside,
        ...this.$refs.items
      ]

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      }, 0.05)
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.partners
  .partners__wrapper

    .header
      .header__main.hgroup
        h2.hgroup__heading(ref="heading") {{ $content.title }}
        .hgroup__description(ref="subheading") {{ $content.description }}
      .header__aside.aside(ref="aside")
        base-button.aside__button(:label="$content.link.name", :url="$content.link.url", target="_blank")

    .content
      ul.content__list.list
        li.list__item(v-for="partner in $content.items" ref="items", @mouseenter="hover = true", @mouseleave="hover = false")
          a.link(:href="partner.url" target="_blank")
            .link__image
              img(:src="partner.image.url")
            .link__label {{ partner.title }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.partners
  position relative
  display flex
  justify-content center
  padding-top 90px
  padding-bottom 90px

  &__wrapper
    display flex
    flex-direction column
    max-width 1218px
    width 100%
    padding 0 105px

    +hd()
      max-width 1260px
      padding-left 60px
      padding-right 0

    +mobile()
      padding-left 29px
      padding-right 24px

.header
  display flex
  justify-content space-between
  padding-bottom 45px
  padding-right 18px

  +tablet()
    margin-bottom 80px
    padding 0

  &__main
    width 495px

  &__aside
    flex 1 0 auto

.hgroup
  display flex
  flex-direction column

  &__heading
    font-weight 400
    font-size 56px
    line-height 57px
    color blue
    padding-bottom 40px

    +below(1023px)
      font-size 46px
      line-height 50px
      font-weight normal

  &__description
    font-size 17px
    line-height 25px

    +mobile()
      font-size 13px
      line-height 20px

.aside
  display flex
  justify-content flex-end
  align-items flex-start
  padding-top 14px

  +mobile()
    position absolute
    bottom 0
    left 50%
    transform translateX(-50%)

  // &__button

.content
  display flex
  padding-top 5px

  &__list
    width 912px

    +hd()
      width 960px

    +laptop()
      width 760px

    +devices()
      width 100%

.list
  display flex
  flex-wrap wrap
  list-style-type none

  &__item
    width 25%
    padding-top 19px
    padding-right 60px
    padding-bottom 19px

    +tablet()
      width 33%
      padding-right 40px

    +mobile()
      width 50%
      padding-right 40px

.link
  display flex
  flex-direction column

  &:hover &__image
    opacity 1

  &__image
    display flex
    align-items center
    height 114px
    opacity 0.35
    transition opacity .1s

    img
      max-width 100%

  &__label
    font-weight 500
    font-size 12px
    line-height 17px
    text-transform lowercase

</style>



// WEBPACK FOOTER //
// partners.vue?2041c408